import defaultCatalogImage from '@/assets/icons/optional-fees/panel/image.svg'

export const DEFAULT_CATALOG_IMAGE_URL = defaultCatalogImage
